<template>
    <div class="text-center text-white font-medium mb-2">
        Loading...
    </div>
</template>